import urls from "../../../../../global/constants/UrlConstants";
import {
  getCallParams,
  getFileCallParams,
  makeCall,
} from "../../../../../utils/service";

export async function ImageUpLoad(file: any) {
  try {
    const callParams = await getFileCallParams(file);
    const response = await makeCall(urls.IMAGEUPLOAD, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addUserDoc(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDUSERDOC, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updateUploadLead(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATELEADUPLOADEDETAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getUserDoc(userId: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETUSERDOC + userId, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
